import {Action, ActionType, Selector, State, StateContext} from '@ngxs/store';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SetUserHash} from "@sharedAl/store/actions/user.action";

interface AutoLiquidationUserStateModel {
  hash: string,
}
@State<AutoLiquidationUserStateModel>({
  name: 'autoLiquidationAuth',
  defaults: {
    hash: null,
  }
})
@Injectable()
export class AuthState {

  constructor(private http: HttpClient) {
  }

  @Selector()
  static loggedIn(state: AutoLiquidationUserStateModel): boolean {
    return !!(state && state.hash);
  }
  @Selector()
  static loggedOut(state: AutoLiquidationUserStateModel): boolean {
    return !state.hash
  }

  @Selector()
  static hash(state: AutoLiquidationUserStateModel): string {
    return state.hash;
  }

  @Action(<ActionType>SetUserHash)
  setUserHash(ctx: StateContext<AutoLiquidationUserStateModel>, action: SetUserHash) {
     ctx.patchState({
       hash: action.hash
     })
  }
}
